import { deserializeLayout, serializeLayout } from "@wormhole-foundation/sdk-base";
import { porticoFlagSetLayout, porticoPayloadLayout } from "./porticoLayout.js";
import "../../registry.js";
export var PorticoBridge;
(function (PorticoBridge) {
    const _protocol = "PorticoBridge";
    const _transferPayloads = ["Transfer"];
    const _payloads = [..._transferPayloads];
    PorticoBridge.deserializePayload = (data) => {
        return deserializeLayout(porticoPayloadLayout, data);
    };
    PorticoBridge.serializePayload = (msg) => {
        return serializeLayout(porticoPayloadLayout, msg);
    };
    PorticoBridge.deserializeFlagSet = (data) => {
        return deserializeLayout(porticoFlagSetLayout, data);
    };
    PorticoBridge.serializeFlagSet = (flags) => {
        return serializeLayout(porticoFlagSetLayout, flags);
    };
})(PorticoBridge || (PorticoBridge = {}));
//# sourceMappingURL=portico.js.map